export default "__VITE_ASSET__Cl5wWn1D__"